import { render, staticRenderFns } from "./reading-calculator.vue?vue&type=template&id=2b879e42&"
import script from "./reading-calculator.vue?vue&type=script&lang=js&"
export * from "./reading-calculator.vue?vue&type=script&lang=js&"
import style0 from "./reading-calculator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports